/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const mobilephone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M7.2 3.227H9m-.88 8.77h.023M4.636 1h7c.352 0 .637.285.637.636v12.728a.636.636 0 0 1-.637.636h-7A.636.636 0 0 1 4 14.364V1.636C4 1.285 4.285 1 4.636 1Z"
    />
  </svg>
)
export default mobilephone
